import { render, staticRenderFns } from "./ViewUserProfileDialog.vue?vue&type=template&id=0db65ca7&scoped=true"
import script from "./ViewUserProfileDialog.vue?vue&type=script&lang=js"
export * from "./ViewUserProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewUserProfileDialog.vue?vue&type=style&index=0&id=0db65ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db65ca7",
  null
  
)

export default component.exports